import React, { FC } from 'react'
import { Card } from 'react-bootstrap'
import { IProduct } from '../../types/product'
import ProductCardHeader from './components/ProductCardHeader'
import ProductCardBody from './components/ProductCardBody'
import { useAppSelector } from '../../hooks/useAppSelector'
import style from './Styles/index.module.scss'
import { AnimatedContainer } from '../AnimatedContainer'
import { User } from '../../entity/User'
import { selectProductsProductLoading } from '../../store/selectors/productsSelectors'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

interface IProductCard {
    product: IProduct
    className?: string
    groupId?: string
    index?: any
}

const ProductCard: FC<IProductCard> = ({
    product,
    className,
    groupId,
    index,
}: IProductCard) => {
    const productLoading = useAppSelector(selectProductsProductLoading)
    const isLoading = productLoading === product.guid
    const authUser = new User()

    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({ id: product.guid })

    const styles = {
        transform: CSS.Transform.toString(transform),
        transition: transition || 'transform 150ms ease',
        // cursor: 'grab',
    }

    return (
        <AnimatedContainer loading={isLoading}>
            {Number.isSafeInteger(index) ? (
                <div
                    ref={setNodeRef}
                    style={styles}
                    {...attributes}
                    {...listeners}
                    // isDragDisabled={!authUser.isAdministratorOrOwner()} // TODO disable drag by user role
                >
                    <Card className={`h-auto ${style.productCard}`}>
                        <ProductCardHeader
                            groupId={groupId}
                            product={product}
                        />
                        <ProductCardBody product={product} />
                    </Card>
                </div>
            ) : (
                <Card
                    className={`m-2 h-auto ${className}`}
                    style={{ width: '23rem' }}
                >
                    <ProductCardHeader
                        groupId={groupId}
                        product={product}
                    />
                    <ProductCardBody product={product} />
                </Card>
            )}
        </AnimatedContainer>
    )
}

export default ProductCard
